// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__3m76P","input":"Form_input__bZCzk","label":"Form_label__1_QS9","loggin":"Form_loggin__3EV2o","or":"Form_or__1Kv4t","password":"Form_password__11rLn"};